import { useState } from "react";

export default function StepConfigPanel({
  stepOptions,
  onAddStep,
  onRemoveStep,
  onUpdateStep,
  onResetSteps,
  onReorderSteps,
  onClose,
}) {


  const [folderPath, setFolderPath] = useState("기본 폴더");
  const [newLabel, setNewLabel] = useState("");
  const [newTarget, setNewTarget] = useState("");
  const [newNote, setNewNote] = useState("");
  const [newIcon, setNewIcon] = useState("📌");
  const [newMin, setNewMin] = useState(5);
  const [newColor, setNewColor] = useState("#64748b");
  const [newInputType, setNewInputType] = useState("note");

  const [editingKey, setEditingKey] = useState(null);
  const [editDraft, setEditDraft] = useState({});
  const [showIconPicker, setShowIconPicker] = useState(false);

  
  const startEdit = (opt) => {
    setEditingKey(opt.key);
    setEditDraft({
      label: opt.label,
      icon: opt.icon,
      color: opt.color,
      defaultMin: opt.defaultMin,
      defaultTarget: opt.defaultTarget || "",
      defaultNote: opt.defaultNote || "",
      folder: opt.folder || "기본 폴더",
    });
  };
  
  const saveEdit = (key) => {
    const target = stepOptions.find((s) => s.key === key);
    if (!target) { setEditingKey(null); return; }

    // 서버는 snake_case (default_min) 를 받음. defaultMin → default_min 변환 필수.
    onUpdateStep(target.id, {
      label:       editDraft.label,
      icon:        editDraft.icon,
      color:       editDraft.color,
      default_min: editDraft.defaultMin,   // ← camelCase 아님 주의
      folder:      editDraft.folder,
    });
    setEditingKey(null);
  };




  const handleAdd = () => {
    if (!newLabel.trim()) {
      alert("항목 이름을 입력해주세요.");
      return;
    }

    onAddStep({
      folder: folderPath.trim() || "기본 폴더",
      label: newLabel.trim(),
      icon: newIcon,
      color: newColor,
      defaultMin: newMin,
      defaultTarget: newTarget.trim(),
      defaultNote: newNote.trim(),
      inputType: newInputType,
    });

    setNewLabel("");
    setNewTarget("");
    setNewNote("");
    setNewIcon("📌");
    setNewMin(5);
    setNewColor("#64748b");
    setNewInputType("note");
  };

  const moveStep = (index, direction) => {
    const nextIndex = index + direction;
    if (nextIndex < 0 || nextIndex >= stepOptions.length) return;

    const newSteps = [...stepOptions];
    const temp = newSteps[index];
    newSteps[index] = newSteps[nextIndex];
    newSteps[nextIndex] = temp;

    if (onReorderSteps) {
      onReorderSteps(newSteps);
    }
  };

  const handleResetClick = () => {
    if (window.confirm("등록된 모든 항목을 삭제하시겠습니까?")) {
      onResetSteps();
    }
  };

  const btnPrimary = { padding: "6px 16px", borderRadius: 6, border: "none", background: "#2563eb", color: "#fff", fontSize: 12, fontWeight: 500, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0, width: "fit-content", display: "inline-block" };
  const btnAction = { padding: "6px 14px", borderRadius: 6, border: "0.5px solid #e2e8f0", background: "#fff", color: "#0f172a", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0, width: "fit-content", display: "inline-block" };

  const inputStyle = { border: "0.5px solid #cbd5e1", borderRadius: 6, padding: "6px 10px", fontSize: 12, outline: "none", boxSizing: "border-box", color: "#0f172a" };
  const moveBtnStyle = { padding: "2px 6px", border: "0.5px solid #cbd5e1", background: "#fff", borderRadius: 4, color: "#0f172a", fontSize: 10, cursor: "pointer", fontWeight: "bold", width: "fit-content", display: "inline-block" };

  return (
    <div style={{
      background: "#fff", border: "0.5px solid #e2e8f0",
      borderRadius: 12, padding: "16px", marginBottom: 14, width: 740, // 👈 740px 박스 크기 강제 고정
      boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column"
    }}>
      
      {/* 💡 타이틀 바 개조: width: 100%를 제거하고 본체 내에 정확히 안착하도록 조정 */}
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between", 
        marginBottom: 12,
        boxSizing: "border-box"
      }}>
        <span style={{ fontSize: 14, fontWeight: 600, color: "#0f172a" }}>🛠 항목 관리 및 추가</span>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <button style={{ ...btnAction, color: "#ef4444", borderColor: "#fecaca" }} onClick={handleResetClick}>
            전체 항목 삭제
          </button>
          <button style={btnAction} onClick={onClose}>✕ 닫기</button>
        </div>
      </div>

      {/* 리스트 목록 영역 */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 16, maxHeight: 180, overflowY: "auto", borderBottom: "1px solid #f1f5f9", paddingBottom: 10, boxSizing: "border-box" }}>
        {stepOptions.length === 0 ? (
          <div style={{ color: "#475569", fontSize: 13, padding: "10px 0", textAlign: "center" }}>
            등록된 항목이 없습니다. 아래에서 새 항목을 생성해주세요.
          </div>
        ) : (

          stepOptions.map((opt, index) => (
            <div key={opt.key} style={{ display: "flex", flexDirection: "column", gap: 4, background: "#f8fafc", padding: "6px 10px", borderRadius: 6, boxSizing: "border-box" }}>
          
              {editingKey === opt.key ? (
                /* ─── 편집 모드 ─── */
                <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                  <input value={editDraft.folder}        onChange={e => setEditDraft(d => ({ ...d, folder: e.target.value }))}        style={{ ...inputStyle, width: 80 }} placeholder="폴더" />
                  <input value={editDraft.icon}          onChange={e => setEditDraft(d => ({ ...d, icon: e.target.value }))}          style={{ ...inputStyle, width: 30, textAlign: "center", padding: "6px 0" }} />
                  <input value={editDraft.label}         onChange={e => setEditDraft(d => ({ ...d, label: e.target.value }))}         style={{ ...inputStyle, width: 100 }} placeholder="항목명" />
                  <input value={editDraft.defaultTarget} onChange={e => setEditDraft(d => ({ ...d, defaultTarget: e.target.value }))} style={{ ...inputStyle, width: 90 }} placeholder="상대방" />
                  <input value={editDraft.defaultNote}   onChange={e => setEditDraft(d => ({ ...d, defaultNote: e.target.value }))}   style={{ ...inputStyle, flex: 1, minWidth: 80 }} placeholder="내용" />
                  <input type="color" value={editDraft.color} onChange={e => setEditDraft(d => ({ ...d, color: e.target.value }))} style={{ width: 28, height: 28, border: "0.5px solid #cbd5e1", borderRadius: 6, cursor: "pointer", padding: 2, flexShrink: 0 }} />
                  <div style={{ display: "flex", alignItems: "center", border: "0.5px solid #cbd5e1", borderRadius: 6, padding: "0 4px", height: 28, background: "#fff", flexShrink: 0 }}>
                    <button type="button" onClick={() => setEditDraft(d => ({ ...d, defaultMin: Math.max(1, d.defaultMin - 1) }))} style={{ background: "none", border: "none", cursor: "pointer", padding: "0 4px", fontWeight: "bold" }}>−</button>
                    <span style={{ fontSize: 12, minWidth: 24, textAlign: "center", color: "#0f172a" }}>{editDraft.defaultMin}m</span>
                    <button type="button" onClick={() => setEditDraft(d => ({ ...d, defaultMin: d.defaultMin + 1 }))} style={{ background: "none", border: "none", cursor: "pointer", padding: "0 4px", fontWeight: "bold" }}>+</button>
                  </div>
                  <button onClick={() => saveEdit(opt.key)}   style={{ ...btnPrimary, padding: "5px 12px" }}>저장</button>
                  <button onClick={() => setEditingKey(null)} style={{ ...btnAction,  padding: "5px 10px" }}>취소</button>
                </div>
              ) : (
                /* ─── 일반 표시 모드 ─── */
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {/* 위아래 이동 버튼 */}
                  <div style={{ display: "flex", gap: 2, flexShrink: 0 }}>
                    <button onClick={() => moveStep(index, -1)} disabled={index === 0}                      style={{ ...moveBtnStyle, opacity: index === 0 ? 0.3 : 1, cursor: index === 0 ? "default" : "pointer" }}>▲</button>
                    <button onClick={() => moveStep(index, 1)}  disabled={index === stepOptions.length - 1} style={{ ...moveBtnStyle, opacity: index === stepOptions.length - 1 ? 0.3 : 1, cursor: index === stepOptions.length - 1 ? "default" : "pointer" }}>▼</button>
                  </div>
          
                  {/* 폴더명 */}
                  <span style={{ fontSize: 12, color: "#0f172a", fontWeight: 500, width: 70, flexShrink: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    [{opt.folder || "기본"}]
                  </span>
          
                  {/* 항목 뱃지 */}
                  <span style={{ fontSize: 12, padding: "2px 8px", borderRadius: 20, background: opt.color + "18", color: opt.color, border: `0.5px solid ${opt.color}40`, width: 110, textAlign: "center", flexShrink: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {opt.icon} {opt.label}
                  </span>
          
                  {/* 내용 */}
                  <span style={{ fontSize: 12, color: "#0f172a", flex: 1, minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {opt.defaultTarget ? `👤 ${opt.defaultTarget} ` : ""}{opt.defaultNote ? `📝 ${opt.defaultNote}` : ""}
                  </span>
          
                  {/* 시간 */}
                  <span style={{ fontSize: 12, color: "#0f172a", width: 35, textAlign: "right", flexShrink: 0 }}>{opt.defaultMin}분</span>
          
                  {/* 수정 + 삭제 버튼 묶음 */}
                  <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                    <button onClick={() => startEdit(opt)} style={{ padding: "4px 8px", borderRadius: 6, border: "0.5px solid #bfdbfe", background: "#eff6ff", color: "#2563eb", fontSize: 11, fontWeight: 500, cursor: "pointer" }}>
                      수정
                    </button>
                    <button onClick={() => onRemoveStep(opt.key)} style={{ padding: "4px 8px", borderRadius: 6, border: "0.5px solid #fecaca", background: "#fff", color: "#ef4444", fontSize: 11, fontWeight: 500, cursor: "pointer" }}>
                      삭제
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {/* 하단 생성 입력 폼 영역 */}
      <div style={{ display: "flex", alignItems: "center", gap: 6, boxSizing: "border-box" }}>
        <input 
          value={folderPath} 
          onChange={e => setFolderPath(e.target.value)} 
          placeholder="폴더 위치" 
          style={{ ...inputStyle, width: 90, flexShrink: 0 }} 
        />

        <div style={{ display: "flex", alignItems: "center", gap: 2, flex: 1, minWidth: 100 }}>

          <div style={{ position: "relative", flexShrink: 0 }}>
            <button
              type="button"
              onClick={() => setShowIconPicker(v => !v)}
              style={{ ...inputStyle, width: 32, textAlign: "center", padding: "6px 0", cursor: "pointer", background: "#fff" }}
            >
              {newIcon}
            </button>
            {showIconPicker && (
              <div style={{
                position: "absolute", top: 34, left: 0, zIndex: 100,
                background: "#fff", border: "0.5px solid #e2e8f0",
                borderRadius: 8, padding: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                display: "flex", flexWrap: "wrap", gap: 4, width: 200,
              }}>
                {["📞","🎧","📌","📋","🏢","💬","🤝","🚗","🔍","📝","📊","📅","✅","⚠️","🔔","📧","💼","🏃","📎","🗂️","💡","🔧","📣","🤙","👥","📤","📥","🗒️","⏰","🎯"].map(emoji => (
                  <button
                    key={emoji}
                    type="button"
                    onClick={() => { setNewIcon(emoji); setShowIconPicker(false); }}
                    style={{
                      background: newIcon === emoji ? "#eff6ff" : "none",
                      border: newIcon === emoji ? "1px solid #3b82f6" : "1px solid transparent",
                      borderRadius: 4, cursor: "pointer", fontSize: 16, padding: "2px 4px",
                    }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            )}
          </div>




          <input value={newLabel} onChange={e => setNewLabel(e.target.value)} placeholder="항목 이름 *" style={{ ...inputStyle, width: "100%" }} />
        </div>

        <input 
          value={newTarget} 
          onChange={e => setNewTarget(e.target.value)} 
          placeholder="상대방 입력" 
          style={{ ...inputStyle, width: 100, flexShrink: 0 }} 
        />

        <input 
          value={newNote} 
          onChange={e => setNewNote(e.target.value)} 
          placeholder="내용 입력" 
          style={{ ...inputStyle, flex: 1.2, minWidth: 100 }} 
        />

        <input type="color" value={newColor} onChange={e => setNewColor(e.target.value)} style={{ width: 28, height: 28, border: "0.5px solid #cbd5e1", borderRadius: 6, cursor: "pointer", padding: 2, flexShrink: 0, boxSizing: "border-box" }} />
        
        <div style={{ display: "flex", alignItems: "center", border: "0.5px solid #cbd5e1", borderRadius: 6, padding: "0 4px", height: 28, background: "#fff", flexShrink: 0, boxSizing: "border-box" }}>
          <button type="button" onClick={() => setNewMin(m => Math.max(1, m - 1))} style={{ background: "none", border: "none", cursor: "pointer", color: "#0f172a", padding: "0 4px", fontWeight: "bold" }}>−</button>
          <span style={{ fontSize: 12, minWidth: 24, textAlign: "center", color: "#0f172a" }}>{newMin}m</span>
          <button type="button" onClick={() => setNewMin(m => m + 1)} style={{ background: "none", border: "none", cursor: "pointer", color: "#0f172a", padding: "0 4px", fontWeight: "bold" }}>+</button>
        </div>

        <button 
          style={btnPrimary} 
          onClick={handleAdd}
        >
          + 항목 생성
        </button>
      </div>
    </div>
  );
}